export default "__VITE_ASSET__495cdab0__"